import axios from "axios";
import { config } from "../config";

export class DataExchangeService {
  /*********** List ***********/
  public list = async (): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.get(serverUrl + "data-exchange");
      return response.data;
    } catch (error) {
      return { message: "error" };
    }
  };

  /*********** Create ***********/
  public create = async (data: any): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.post(serverUrl + "data-exchange", data);
      return response.data;
    } catch (error) {
      return { message: "error" };
    }
  };

  /*********** Update ***********/
  public update = async (id: number, data: any): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.patch(
        serverUrl + `data-exchange/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      console.log(error);
      return { message: "error" };
    }
  };

  /*********** DELETE ***********/
  public delete = async (id: number): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.delete(serverUrl + `data-exchange/${id}`);
      return response.data;
    } catch (error) {
      console.log(error);
      return { message: "error" };
    }
  };
}
